import { } from '@cruxcode/paintkit/bundle.js'

var active = false;

export function onImageHighlightClick() {
    active = true;
    let pages = document.getElementsByClassName("page");
    for (let i = 0; i < pages.length; i++) {
        createBoard(pages[i])
    }
}

export function startImageHighlightPlugin(eventBus) {
    document.getElementById("highlightMenu").addEventListener("click", () => {
        console.log("image highlight icon clicked");
        onImageHighlightClick();
    });
    console.log("eventbus is", eventBus)
    if (eventBus) {
        eventBus.on("textlayerrendered", (evt) => {
            console.log("[@cruxcode/testpdfviewer] textlayerrendered", evt);
            if (active && evt.source.textLayerDiv.parentElement.querySelector(".m-board")) {
                let board = evt.source.textLayerDiv.parentElement.querySelector(".m-board");
                console.log("board to be removed is", board)
                evt.source.textLayerDiv.parentElement.removeChild(board);
                createBoard(evt.source.textLayerDiv.parentElement);
            } else if(active){
                createBoard(evt.source.textLayerDiv.parentElement);
            }
        })
    }
}

window.addEventListener("keypress", (e) => {
    console.log(e);
    if (e.key == "e") {
        active = false;
        let boards = document.querySelectorAll(".m-board");
        if(boards && boards.length > 0){
            for(let i = 0; i < boards.length; i++){
                boards[i].parentElement.removeChild(boards[i]);
            }
        }
    }
    if(e.key == "d"){
        let selected = document.querySelector(".cruxselected");
        selected.parentElement.parentElement.removeChild(selected.parentElement);
    }
});

window.addEventListener("cruxactivitycomplete", (ev)=>{
    let page = ev.detail.activity.div.parentElement.parentElement;
    ev.detail.activity.div.parentElement.classList.remove("m-board");
    ev.detail.activity.div.parentElement.classList.add("m-board-done");
    snapBoard(ev.detail.activity.div.parentElement);
    createBoard(page);
});

function createBoard(container) {
    let board = document.createElement("div");
    board.classList.add("m-board");
    container.style.position = "relative";
    board.style.position = "absolute";
    board.style.top = 0;
    board.style.left = 0;
    board.style.width = container.style.width;
    board.style.height = container.style.height;
    container.appendChild(board);
    let appConfig = new window.Art.ActivityConfig();
    appConfig.shapeCSS = { fill: "rgba(255, 0, 0, 0.2)" }
    let activity = new window.Art.Activity(board, 0, appConfig);
    console.log("activity imported", activity);
    activity.run();
}

function snapBoard(board){
    if(board && board.childNodes.length > 0){
        let child = board.childNodes[0];
        board.style.top = child.style.top;
        board.style.left = child.style.left;
        board.style.height = child.style.height;
        board.style.width = child.style.width;
        child.style.top = "0";
        child.style.left = "0";
    }
}